import { Button, Stack, Typography } from "@mui/material";

import { useStore, observer } from "../../../../../../../service/mobx";
import { PaperCardSize2 } from "../../../../../../../component/Card/Paper";
import {
  CardExternalSize2,
  CardExternalCodeSize2
} from "../../../../../../../component/Card/External";
import { CardVideoSize1 } from "../../../../../../../component/Card/External/Video";
import { TaskSize2 } from "../../../../../../../component/Card/Task";
import { CardUserSize2 } from "../../../../../../../component/Card/User";
import { ShallowLink } from "../../../../../../../component/Link/Shallow";

function Section({ tab, url, title, items, cardType, showAll = false }) {
  const { reader } = useStore();
  const selected = showAll || url.includes(tab);
  const conferenceRecommendations =
    reader.whiteLabelled && title.includes(" 20");
  const previewSize = conferenceRecommendations ? 3 : 1;
  const content = selected
    ? items
    : tab === "paper"
    ? items.slice(0, previewSize)
    : [];
  const map = {
    task: [TaskSize2, "tag"],
    paper: [PaperCardSize2, "paper"],
    user: [CardUserSize2, "user"],
    external: [CardExternalSize2, "content"],
    code: [CardExternalCodeSize2, "content"],
    video: [CardVideoSize1, "video"]
  };
  const [Card = () => null, entity = "Null"] = map[cardType] || [];
  const moreButton = selected === false && 1 < items.length;

  return content.length === 0 ? null : (
    <Stack useFlexGap spacing={1} mb={moreButton ? 0 : 3}>
      <Typography
        variant="labelLg"
        color="surface.on.color"
        textTransform="capitalize"
      >
        {title}
      </Typography>
      {showAll ? (
        <Stack spacing={2}>
          {content.map(content => (
            <Card
              key={content.id || content.node?.id || content.url}
              {...{ [entity]: content }}
            />
          ))}
        </Stack>
      ) : (
        content.map(content => (
          <Card
            key={content.id || content.node?.id || content.url}
            {...{ [entity]: content }}
            externalType={title}
          />
        ))
      )}
      {moreButton ? (
        <Button
          href={url}
          LinkComponent={ShallowLink}
          sx={theme => ({
            px: 2,
            alignSelf: "center",
            color: "surface.on.color",
            borderRadius: theme.shape.round
          })}
        >
          {`more (${items.length - previewSize})`}
        </Button>
      ) : null}
    </Stack>
  );
}

export default observer(Section);
